import type { MouseEvent } from 'react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { VIEWER_CONTROL_CHROME_STYLE } from './viewerControlChrome';

type ModelViewerHelpButtonProps = {
  onClick: () => void;
  zIndex?: number;
};

export function ModelViewerHelpButton({ onClick, zIndex = 12 }: ModelViewerHelpButtonProps) {
  const { t } = useTranslation();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <Tooltip label={t('modelViewer.help.button')} withArrow position="top">
      <ActionIcon
        variant="default"
        radius="xl"
        size={40}
        aria-label={t('modelViewer.help.button')}
        onClick={handleClick}
        style={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          zIndex,
          ...VIEWER_CONTROL_CHROME_STYLE,
        }}
      >
        <IconHelp size={20} stroke={2} />
      </ActionIcon>
    </Tooltip>
  );
}
